export default __webpack_public_path__ + "static/media/ee.93dc2ce5.jpg";